import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUp, ArrowUpRight } from 'lucide-react';
import ShopifySelectBadge from './ShopifySelectBadge';
import { projects } from '../../data/projects';
import styles from './Footer.module.css';

export default function Footer() {
  const { t, i18n } = useTranslation(['studio', 'common', 'projects']);
  const prefix = i18n.language?.startsWith('es') ? '/es' : '';
  const groups = [
    { title: t('footer.studio'), links: [
      ['/about', t('nav.about', { ns: 'common' })], ['/clients', t('nav.clients', { ns: 'common' })],
      ['/projects', t('nav.projects', { ns: 'common' })], ['/blog', t('nav.blog', { ns: 'common' })],
    ] },
    { title: t('footer.expertise'), links: [
      ['/services/ai-implementation', t('footer.ai')], ['/services/ai-agents', t('footer.agents')],
      ['/services/shopify', 'Shopify'], ['/services/creative-engine', t('footer.creative')],
      ['/services/seo', 'SEO'], ['/services/geo', t('footer.aiSearch')],
      ['/services/cro', 'CRO'], ['/services/saas', 'SaaS & Apps'],
    ] },
    { title: t('footer.lab'), links: [
      ...projects.map(p => [`/projects/${p.slug}`, t(`items.${p.slug}.name`, { ns: 'projects' })]),
      ['/apps/ruleforge', 'RuleForge'],
    ] },
  ];
  return <footer className={styles.footer}>
    <div className={styles.top}>
      <div className={styles.introduction}>
        <p className={styles.statement}>{t('footer.line1')}<br /><span>{t('footer.line2')}</span></p>
        <a className={styles.email} href="mailto:hello@jamaklab.com">hello@jamaklab.com<ArrowUpRight size={23} /></a>
        <ShopifySelectBadge variant="white" size="xl" className={styles.partner} />
      </div>
      <div className={styles.directory}>{groups.map(group => <nav key={group.title} aria-label={group.title}>
        <h2>{group.title}</h2><ul>{group.links.map(([path, name]) => <li key={path}><Link to={`${prefix}${path}`}>{name}</Link></li>)}</ul>
      </nav>)}</div>
    </div>
    <div className={styles.signature}>
      <Link to={prefix || '/'} aria-label={t('footer.home')} className={styles.wordmark}>
        <img src="/images/logos/logo-jamak-white.svg" alt="" width="1806" height="593" loading="lazy" />
      </Link>
      <button className={styles.up} type="button" aria-label={t('footer.backToTop', { ns: 'common' })}
        onClick={() => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })}><ArrowUp strokeWidth={1} /></button>
    </div>
    <div className={styles.bottom}>
      <span>© {new Date().getFullYear()} JAMAK</span><span>{t('footer.note')}</span>
      <a href="https://github.com/JAMAKWEB" target="_blank" rel="noopener noreferrer">GitHub<ArrowUpRight size={13} /></a>
      <span>EN / ES</span>
    </div>
  </footer>;
}
